<template>
	<div id="not-found" class="view">
		<div class="single-modal-container">
			<div>
				<i class="fa-sharp fa-solid fa-exclamation-triangle"></i>
				<p>404 - Not Found</p>
			</div>
		</div>
	</div>
</template>
<style scoped>
#not-found {
	font-size: 3rem;
	text-align: center;
}

div > i {
	color: #fff;
}
</style>